"use client";
import { cn as e } from "../../utils/cn.js";
const r = {
  base: e(
    "relative flex flex-col items-center justify-center gap-1",
    "min-w-18 min-h-25 rounded-2xl p-2",
    "text-card-foreground bg-card",
    "text-center text-sm/4 font-medium",
    "inset-ring-1 inset-ring-card-border"
  ),
  textPlate: e("bg-popup w-full rounded-sm p-0.5"),
  iconDone: e(
    "bg-linear-to-r from-component/60 to-component bg-clip-text !text-transparent"
  ),
  timer: e(
    "flex items-center gap-0.5",
    "bg-linear-to-r from-primary/60 to-primary text-primary-foreground",
    "-m-1 w-[calc(100%+0.5rem)] rounded-xl p-1",
    "text-[0.5rem]/4"
  ),
  state: {
    done: e("text-card-foreground/60 inset-ring-2"),
    current: e("inset-ring-4 inset-ring-component"),
    active: e("shadow-[0_0_1.5rem_0_var(--color-component)]")
  }
};
export {
  r as STYLES
};
